import './portfolio.css'
import Projects from './Projects'
import ProjectsCategories from './ProjectsCategories'
import data from './data'
import Card from '../../components/Card'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useState, useEffect } from 'react';

function useMediaQuery(query) {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    const listener = (event) => setMatches(event.matches);

    mediaQueryList.addListener(listener);
    return () => mediaQueryList.removeListener(listener);
  }, [query]);

  return matches;
}

const Portfolio = () => {
  useEffect(() => {
    AOS.init({duration: 2000})
  }, [])

  const isTabletOrSmaller = useMediaQuery('(max-width: 600px)');

  const [projects, setProjects] = useState(data);

  const categories = data.map(item => item.category);
  const uniqueCategories = ["all", ...new Set(categories)];
  
  const filterProjectsHandler = (category) => {
    if(category === "all") {
      setProjects(data);
      return;
    }

    const filterProjects = data.filter(project => project.category === category);
    setProjects(filterProjects);
  }
  

  //  return (
  //   <section id="portfolio">
  //     <h2 data-aos={isTabletOrSmaller ? undefined : "fade-up"}>Recent Projects</h2>
  //     <p data-aos={isTabletOrSmaller ? undefined : "fade-up"}>
  //     Check out some of the projects I worked on. 
  //     </p>
  //     <div className="container portfolio__container" data-aos={isTabletOrSmaller ? undefined : "fade-up"}>
  //       <ProjectsCategories categories={uniqueCategories} onFilterProjects={filterProjectsHandler}/>
  //       <Projects projects={projects}/>
  //     </div>
  //   </section>
  // )
}

export default Portfolio